import * as actionTypes from '../actions/actionsTypes';

const initialState = '';

const setAddressBookSearchParams = (state, action) => {
  return action.data;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETADDRESSBOOKSEARCHPARAMS:
      return setAddressBookSearchParams(state, action);
    default:
      return state;
  }
};

export default reducer;
